import authRequest, { jsonHeaders } from 'src/utils/fetch';

export const formatRemovedLine = (
  content: string | null | undefined
): string => {
  if (!content) return '';
  if (content.charAt(0) === '+') return `-${content.slice(1)}`;
  if (content.charAt(0) !== '-') return `-${content}`;
  return content;
};

export const postCodeSuggestions = async (
  body: any,
  repositoryOwner: string,
  repositorySlug: string,
  pullRequestId: string
) => {
  const url = `/!api/internal/repositories/${repositoryOwner}/${repositorySlug}/pullrequests/${pullRequestId}/suggestions/`;

  try {
    const res = await fetch(
      authRequest(url, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: jsonHeaders,
      })
    );
    if (!res.ok) throw new Error(res.statusText);
    const json = await res.json();
    return json;
  } catch (e) {
    return null;
  }
};
